export const addressSectionCardStyles = {
	root: {
		overflow: 'hidden',
		width: '100%'
	},

	header: (isLastItem: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		p: 1.5,
		gap: 2,
		maxHeight: 48,
		cursor: 'pointer',
		borderBottom: isLastItem ? 'none' : '1px solid var(--mui-palette-divider)'
	}),

	headerContent: (isDirty: boolean, hasError: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		gap: 1,
		flexGrow: 1,
		overflow: 'hidden',

		...(isDirty && {
			color: 'success.light'
		}),
		...(hasError && {
			color: 'error.main'
		})
	}),

	headerText: {
		fontWeight: 500,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		textAlign: 'left'
	},

	expandIcon: (expanded: boolean) => ({
		transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
		transition: 'transform 0.2s'
	}),

	removeButton: {
		display: 'flex',
		width: 'max-content'
	},

	content: (expanded: boolean) => ({
		display: expanded ? 'block' : 'none',
		p: 2,
		borderBottom: '1px solid var(--mui-palette-divider)'
	}),

	gridContainer: {
		display: 'grid',
		gap: 1.5,
		gridTemplateColumns: { xs: '1fr' }
	},

	fullWidth: {
		gridColumn: '1 / -1'
	},

	primaryToggleWrap: {
		display: 'flex',
		alignItems: 'center',
		height: '100%'
	}
};
